module.exports = __webpack_public_path__ + "static/media/metrocan-logo@2x.a04a2e53.png";